import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../Header.css";
import { trackCoachCtaClick } from "../../analytics/googleAnalytics";

export default function CoachLandingHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const onLanding = location.pathname === "/coaches";
  // En la landing: ancla in-page (#faq). Fuera (p. ej. en el blog): link real a
  // /coaches#faq para que el navegador cargue la landing y haga scroll nativo.
  const navHref = (sectionId) => (onLanding ? sectionId : "/coaches" + sectionId);

  const handleNavClick = (e, sectionId) => {
    setMenuOpen(false);
    if (onLanding) {
      // scroll suave dentro de la propia landing
      e.preventDefault();
      const element = document.querySelector(sectionId);
      if (element) element.scrollIntoView({ behavior: "smooth" });
    }
    // Fuera de la landing dejamos que el <a href="/coaches#..."> navegue normal.
  };

  return (
    <header className={`header ${scrolled ? "header-scrolled" : ""}`}>
      <div className="header-container">
        {/* Logo */}
        <Link to="/" className="logo-link">
          <img
            src="/assets/img/wayo-logo.png"
            alt="Wayo"
            className="logo"
          />
        </Link>

        {/* Desktop menu */}
        <nav className="desktop-menu">
          <a
            href={navHref("#como-funciona")}
            onClick={(e) => handleNavClick(e, "#como-funciona")}
            className="nav-link"
            style={{ fontWeight: 600 }}
          >
            Cómo funciona
          </a>
          <a href={navHref("#precio")} className="nav-link" onClick={(e) => handleNavClick(e, "#precio")} style={{ fontWeight: 600 }}>
            Precio
          </a>
          <a href={navHref("#faq")} className="nav-link" onClick={(e) => handleNavClick(e, "#faq")} style={{ fontWeight: 600 }}>
            Preguntas
          </a>
          <Link to="/blog-entrenadores" className="nav-link" style={{ fontWeight: 600 }}>Blog</Link>
          {/* Harbiz pone «Iniciar sesión» arriba del todo: el coach que ya tiene
              cuenta no tenía por dónde entrar al panel desde aquí. */}
          <Link to="/coach/login" className="nav-link" style={{ fontWeight: 600 }}>Iniciar sesión</Link>
        </nav>

        {/* CTA Button */}
        <div className="header-actions">
          <Link
            to="/coach/register"
            onClick={() => trackCoachCtaClick("coach_landing_header_desktop")}
            style={{
              textDecoration: "none",
              background: "linear-gradient(135deg, #6C3AFF 0%, #8B5CF6 100%)",
              color: "white",
              padding: "12px 28px",
              borderRadius: "50px",
              fontWeight: 700,
              fontSize: "15px",
              transition: "all 0.3s ease",
              display: "inline-block",
              boxShadow: "0 8px 24px rgba(108, 58, 255, 0.3)"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = "0 12px 32px rgba(108, 58, 255, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 8px 24px rgba(108, 58, 255, 0.3)";
            }}
          >
            Empieza gratis
          </Link>
        </div>

        {/* Burger menu */}
        <button
          className={`burger-btn ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menú"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Mobile menu */}
      <div className={`mobile-menu ${menuOpen ? "active" : ""}`}>
        <nav className="mobile-nav">
          <a href={navHref("#como-funciona")} onClick={(e) => handleNavClick(e, "#como-funciona")}>
            Cómo funciona
          </a>
          <a href={navHref("#precio")} onClick={(e) => handleNavClick(e, "#precio")}>Precio</a>
          <a href={navHref("#faq")} onClick={(e) => handleNavClick(e, "#faq")}>Preguntas</a>
          <Link to="/blog-entrenadores" onClick={() => setMenuOpen(false)}>Blog</Link>
          <Link to="/coach/login" onClick={() => setMenuOpen(false)}>Iniciar sesión</Link>
          <Link
            to="/coach/register"
            onClick={() => {
              trackCoachCtaClick("coach_landing_header_mobile");
              setMenuOpen(false);
            }}
            className="mobile-cta"
          >
            Empieza gratis
          </Link>
        </nav>
      </div>
    </header>
  );
}
